import { render, staticRenderFns } from "./CodeGroup.vue?vue&type=template&id=617e1256&"
import script from "./CodeGroup.vue?vue&type=script&lang=js&"
export * from "./CodeGroup.vue?vue&type=script&lang=js&"
import style0 from "./CodeGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports